<template>
    <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
        <FormItem prop="corpName">
            <Input v-model="form.corpName" placeholder="请输入企业名">
            <span slot="prepend">
                    <Icon :size="16" type="ios-home"></Icon>
                </span>
            </Input>
        </FormItem>
        <FormItem prop="userName">
            <Input v-model="form.userName" placeholder="请输入用户名">
                <span slot="prepend">
                    <Icon :size="16" type="ios-person"></Icon>
                </span>
            </Input>
        </FormItem>
        <FormItem prop="password">
            <Input type="password" v-model="form.password" placeholder="请输入密码">
                <span slot="prepend">
                    <Icon :size="14" type="md-lock"></Icon>
                </span>
            </Input>
        </FormItem>
        <FormItem >
            <Checkbox v-model="remember">是否记住密码</Checkbox>
        </FormItem>

        <FormItem>
            <Button @click="handleSubmit" type="primary" long :loading="loading">登录</Button>
        </FormItem>
    </Form>
</template>
<script>
    import {mapActions} from 'vuex'
    import Cookies from 'js-cookie'

    export default {
        name: 'LoginForm',
        props: {
            corpNameRules: {
                type: Array,
                default: () => {
                    return [
                        {required: true, message: '企业名不能为空', trigger: 'blur'}
                    ]
                }
            },
            userNameRules: {
                type: Array,
                default: () => {
                    return [
                        {required: true, message: '账号不能为空', trigger: 'blur'}
                    ]
                }
            },
            passwordRules: {
                type: Array,
                default: () => {
                    return [
                        {required: true, message: '密码不能为空', trigger: 'blur'}
                    ]
                }
            }
        },
        data() {
            return {
                remember:false,
                form: {
                    corpName: '',
                    userName: '',
                    password: ''
                },
                loading:false
            }
        },
        computed: {
            rules() {
                return {
                    corpName: this.corpNameRules,
                    userName: this.userNameRules,
                    password: this.passwordRules
                }
            }
        },
        mounted() {
            this.form.corpName = Cookies.get("corpName");
            if (Cookies.get("remember")){
                this.remember = true;
                this.form.userName = Cookies.get("userName");
                this.form.password = Cookies.get("password");
            }
        },
        methods: {
            ...mapActions([
                'handleLogin',
                'getUserInfo'
            ]),
            handleSubmit() {
                let self = this;
                self.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        let corpName = self.form.corpName;
                        let userName = self.form.userName;
                        let password = self.form.password;
                        self.loading = true;
                        self.handleLogin({corpName, userName, password}).then(res => {
                            if (this.remember){
                                Cookies.set("remember","1",{ expires: 7 });
                                Cookies.set("userName",self.form.userName,{ expires: 7 });
                                Cookies.set("password",self.form.password,{ expires: 7 });
                            }else{
                                Cookies.remove("remember");
                                Cookies.remove("userName");
                                Cookies.remove("password");
                            }
                            Cookies.set("corpName",self.form.corpName,{ expires: 7 });
                            self.getUserInfo().then(res => {
                                self.$router.push({
                                    name: self.$config.homeName
                                })
                            })
                        }, function (e) {
                            self.loading = false;
                            console.log(e);
                        });
                    }
                })
            }
        }
    }
</script>
